module.exports = __webpack_public_path__ + "img/medical-circle.654ed638.svg";